module.exports = __webpack_public_path__ + "static/gpay_monei-2d4374660125f23dd22f823941a34531.svg";